import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserCompanyService } from '../user/usercompany/usercompany.service';
import { TaxesTabService } from './taxes-tabs.service';

@Component({
  selector: 'convfact-taxestabs',
  templateUrl: './taxes-tabs.component.html',
  styleUrls: ['./taxes-tabs.component.scss'],
  standalone: false
})
export class TaxesTabsComponent implements OnInit, OnDestroy {
  routes: { label: string; link: string; enable: boolean }[] = [];
  private sub: Subscription;

  constructor(
    private userCompanyService: UserCompanyService,
    private taxesTabService: TaxesTabService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.load();

    // Back-compat: quarterly-tax-receipt uses the service to navigate back to the list
    this.sub = this.taxesTabService.onEvent$.subscribe(result => {
      if (result && result !== 'create-quarterly-tax-receipt' && !result.startsWith('update-quarterly-tax-receipt-')) {
        this.router.navigate(['/taxes', result]);
      }
    });
  }

  load() {
    this.userCompanyService.loadData().then(result => {
      this.routes = [];

      if (result.facturasRetencion || result.alquilado || result.otrosRetencion) {
        this.routes.push({ label: 'Retenciones IRPF', link: 'retencionesirpf', enable: true });
      }
      if (result.modelo130 || result.modelo131 || result.modelo202) {
        this.routes.push({ label: 'Pagos Fraccionados', link: 'pagosfraccionados', enable: true });
      }
      if (result.modelo303M || result.modelo303C || result.modelo420 || result.modelo421 || result.modelo425 ||
          result.modelo308 || result.modelo347 || result.modelo390 || result.modelo415) {
        this.routes.push({ label: 'IVA / IGIC', link: 'impuestos', enable: true });
      }
      if (result.modelo180 || result.entidadSinAnimoLucro) {
        this.routes.push({ label: 'Resumen anuales', link: 'annual-summary', enable: true });
      }
      this.routes.push({ label: 'Justificantes', link: 'quarter-tax-receipts', enable: true });
      this.routes.push({ label: 'Cierre fiscal', link: 'fiscal-closure', enable: true });

      // Auto-navigate to first section when landing on bare /taxes
      if (this.router.url === '/taxes' && this.routes.length > 0) {
        this.router.navigate(['/taxes', this.routes[0].link]);
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  trackByIndex(i: number) { return i; }
}
